import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import "./EventDetail.css";

class EventDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleJoin = this.handleJoin.bind(this);
    this.onRemoveParticipant = this.onRemoveParticipant.bind(this);
  }
  onRemoveParticipant(participant){
    console.log("EventDetail : onRemoveParticipant()",participant);
    this.props.onRemoveParticipant(participant);
  }
  handleClose(event) {
    
    console.log("EventDetail : handleClose");
    this.props.onClose();
      this.setState({ redirect: true });
  }
  handleRemove() {
    console.log("EventDetail : handleRemove");
    this.props.onRemoveEvent(this.props.event);
    this.handleClose('force');
  }
  handleJoin() {
    console.log("EventDetail : handleJoin",this.props.event.participants);
    this.props.onJoin(this.props.currentUser); 
    this.props.event.participants.push(this.props.currentUser.email);
  }
  render() {
    return this.state.redirect ? (
      <Redirect to="/" />
    ) : (

      <div className="modal is-active">
        <div onClick={this.closeModal} className="modal-background"></div>
        <div className="modal-content"> 
        <div className="box  event-detail">
          <header className="">
            <h1>{this.props.event.title}</h1>
          </header>
          <div className="event-detail-content">
            <div className="content">
              <p>
                <strong>Datum &amp; Zeit:</strong> 
                {this.props.event.start.toLocaleDateString()} -  <strong> von </strong>{this.props.event.start.toLocaleTimeString()}<strong> bis</strong> {this.props.event.end.toLocaleTimeString()} 
              </p>
        
              <p>
                <strong>Beschreibung:</strong>
              </p>  
                <pre>
                {this.props.event.description}
                </pre>
              <p>
                <strong>Veranstalter:</strong>
                {this.props.event.createdBy}
              </p>
              <div>
                <strong>{this.props.event.participants ? this.props.event.participants.length : 0 } Teilnehmer:</strong>
                <ul>
                  {
                    this.props.event.participants ? 
                      this.props.event.participants.map((participant,index) => (
                        <li key={participant}>{participant} {index>0 && <button className="danger button" onClick={()=>this.onRemoveParticipant(participant)} >Löschen</button>}</li>
                      )) : null
                  }
                </ul>
              </div>
              <div>
                <button
                  className="button is-success"
                  disabled={
                    this.props.event.participants ? 
                    this.props.event.createdBy === this.props.currentUser.email ||
                    this.props.event.participants.indexOf(this.props.currentUser.email) !==
                      -1 : false
                  }
                  onClick={this.handleJoin}
                >
                  TEILNEHMEN
                </button>
              </div>
            </div>
          </div> 
          <footer className="event-detail-footer">

            <div className="field is-grouped"> 
                            <div className="control">
                              <Link
                               to="/event-update"
                                className=" button is-link has-margin-left"
                                disabled = {!this.props.currentUser.verified && this.props.currentUser.role!=='admin' &&  this.props.currentUser.email !== this.props.event.createdBy  }
                               
                              >
                                ÄNDERN
                              </Link>
                            </div>
                            <div className="control">
                              <button
                                className=" button is-danger has-margin-left"
                                disabled = {this.props.currentUser.role!=='admin' &&  this.props.currentUser.email !== this.props.event.createdBy  }
                                onClick={this.handleRemove}
                              >
                                LÖSCHEN
                              </button>
                            </div>
                            <div className="control">
                            <button className="button is-text is-outlined has-margin-left"  onClick={this.handleClose}>Abbrechen</button>
                            </div>
                        </div>
          </footer>
         
        </div>
        </div>
      </div>



            

    );
  }
}

export default EventDetail;



// WEBPACK FOOTER //
// ./src/EventDetail.js